export function notifySessionRefresh() {
  window.dispatchEvent(new CustomEvent('wes-session-refresh'));
}
